"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAsyncStatus = void 0;
const types_1 = require("../types");
const withAsyncStatus = (state, action, actionHandler) => {
    switch (action.type) {
        case actionHandler.REQUEST:
            return Object.assign(Object.assign({}, state), { status: types_1.ActionStatus.REQUEST });
        case actionHandler.SUCCESS:
            return Object.assign(Object.assign(Object.assign({}, state), { status: types_1.ActionStatus.SUCCESS }), action.payload);
        case actionHandler.FAIL:
            return Object.assign(Object.assign(Object.assign({}, state), { status: types_1.ActionStatus.FAIL }), action.payload);
        default:
            return state;
    }
};
exports.withAsyncStatus = withAsyncStatus;
//# sourceMappingURL=WithManipulationReducers.js.map